import script from "./MenuHiding.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuHiding.vue?vue&type=script&lang=ts&setup=true"

import "./MenuHiding.vue?vue&type=style&index=0&id=33a71802&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a71802"]])

export default __exports__